export const SIDEBAR_ELEMENT_ID = 'SplitMapTemplate-right-sidebar';
export const LISTINGS_FETCH_DEBOUNCE_MS = 500;
